export const hotDiscussions = [
  {
    id: "d1",
    user: "夜班观察员",
    avatarBg: "bg-primary-500",
    content:
      "顶流这条我站「就是聚餐」。判断依据不是谁的声明，而是剧组工作人员晒的合照时间对得上。反倒是评论区那些「回应太快所以心虚」的逻辑，实在站不住。",
    topicId: "top-lx-nanxing",
    topicTitle: "顶流L姓男星深夜同框聚餐",
    likes: 486,
    time: "12 分钟前",
    replies: 34,
  },
  {
    id: "d2",
    user: "追剧二十年",
    avatarBg: "bg-secondary-500",
    content:
      "换角那条最值得学的其实是方法：不要看爆料，去看成片。正脸镜头在某一集之后断崖式减少，这比任何「剧组内部人士」都可信。",
    topicId: "top-guzhuang-huanjiao",
    topicTitle: "古装剧女主疑遭临阵换角",
    likes: 372,
    time: "38 分钟前",
    replies: 21,
  },
  {
    id: "d3",
    user: "冷静磕学家",
    avatarBg: "bg-accent-600",
    content:
      "劝一句恋综的姐妹们：播完解绑是常态，官号清理素材也是常规操作。别把运营动作当成感情证据，最后受伤的还是自己。",
    topicId: "top-lianzong-fenshou",
    topicTitle: "恋综人气CP疑似互相取关",
    likes: 341,
    time: "1 小时前",
    replies: 47,
  },
  {
    id: "d4",
    user: "现场第一排",
    avatarBg: "bg-secondary-700",
    content:
      "音乐节那场我在。设备问题是真的，跳歌也是真的，但那个全场合唱是我今年看过最好的一段现场。有些东西剪不出来，也吵不出来。",
    topicId: "top-yinyuejie-gedan",
    topicTitle: "音乐节压轴歌手临时改歌单",
    likes: 298,
    time: "2 小时前",
    replies: 18,
  },
  {
    id: "d5",
    user: "剪过片的人",
    avatarBg: "bg-foreground-700",
    content:
      "给大家科普下综艺剪辑：三秒硬切通常是时长逼出来的，属于基本功不到位，不一定是内容有问题。真要藏东西，会剪得更自然。",
    topicId: "top-zongyi-jianji",
    topicTitle: "综艺名场面被剪成三秒",
    likes: 264,
    time: "3 小时前",
    replies: 26,
  },
  {
    id: "d6",
    user: "瓜田里的猹",
    avatarBg: "bg-primary-600",
    content:
      "红毯站位那个真的是典型截图害人。看完整流程就知道是主办方按名单排的，中间还剪掉了一个合影环节。显微镜收一收吧朋友们。",
    topicId: "top-redcarpet-zhanwei",
    topicTitle: "红毯站位引猜测",
    likes: 207,
    time: "5 小时前",
    replies: 12,
  },
  {
    id: "d7",
    user: "不吃解释",
    avatarBg: "bg-accent-500",
    content:
      "解约那条提醒一下：合约类纠纷看的是文本和判决，不是声明。两边各说各话的时候，任何一边的措辞都不值得当作证据。",
    topicId: "top-xuanxiu-jieyue",
    topicTitle: "选秀出身爱豆解约风波升级",
    likes: 176,
    time: "7 小时前",
    replies: 9,
  },
  {
    id: "d8",
    user: "吃瓜不加糖",
    avatarBg: "bg-secondary-600",
    content:
      "路演落泪那个视频我看了三遍。不管别人怎么解读，他在台上停顿的那几秒是真实的。做演员能被角色打动，其实是好事。",
    topicId: "top-yingdi-luyan",
    topicTitle: "影帝新片路演突发落泪",
    likes: 158,
    time: "9 小时前",
    replies: 15,
  },
];

export const communityGroups = [
  {
    id: "g1",
    name: "爆料吃瓜 · 主讨论群",
    platform: "群聊",
    icon: "ri-group-line",
    desc: "日常吃瓜主阵地，热点更新最快，禁止人身攻击与隐私传播。",
    members: "498 / 500",
    status: "快满",
    tags: ["热点同步", "新人友好"],
  },
  {
    id: "g2",
    name: "深夜爆料交流群",
    platform: "群聊",
    icon: "ri-moon-clear-line",
    desc: "只在夜间活跃的深聊群，适合慢慢梳理时间线、比对材料。",
    members: "326 / 500",
    status: "开放中",
    tags: ["深夜档", "时间线整理"],
  },
  {
    id: "g3",
    name: "影视幕后观察组",
    platform: "群聊",
    icon: "ri-clapperboard-line",
    desc: "聚焦影视制作、换角、剧本调整等幕后话题，欢迎从业者潜水交流。",
    members: "212 / 300",
    status: "开放中",
    tags: ["行业视角", "理性讨论"],
  },
  {
    id: "g4",
    name: "爆料吃瓜吧",
    platform: "贴吧",
    icon: "ri-discuss-line",
    desc: "公开讨论版面，每一条瓜都有独立楼层，适合长评和补充材料。",
    members: "12.4 万关注",
    status: "长期开放",
    tags: ["公开版面", "图文补充"],
  },
  {
    id: "g5",
    name: "情绪垃圾桶",
    platform: "群聊",
    icon: "ri-emotion-line",
    desc: "不聊人只聊感受，看瓜看累了可以来这儿吐槽，氛围最松的一间。",
    members: "148 / 200",
    status: "开放中",
    tags: ["低压力", "闲聊"],
  },
  {
    id: "g6",
    name: "粉丝前线速报",
    platform: "频道",
    icon: "ri-flashlight-line",
    desc: "只发不聊，用于快速获取新条目推送，适合只想围观不想说话的朋友。",
    members: "订阅 3.6 万",
    status: "长期开放",
    tags: ["只读", "推送"],
  },
];

export const discussionRules = [
  {
    id: "r1",
    icon: "ri-shield-check-line",
    title: "不传播隐私",
    desc: "不发布住址、联系方式、家人信息等非公开内容，发现即删除。",
  },
  {
    id: "r2",
    icon: "ri-emotion-happy-line",
    title: "对事不对人",
    desc: "可以质疑说法、反驳逻辑，但禁止对网友进行人身攻击或挂人。",
  },
  {
    id: "r3",
    icon: "ri-file-list-3-line",
    title: "带来源讨论",
    desc: "提出观点时尽量附上公开可查的材料，让讨论有落脚点。",
  },
  {
    id: "r4",
    icon: "ri-question-answer-line",
    title: "允许被推翻",
    desc: "这里是讨论区不是法庭，结论随时可能被新信息改写。",
  },
];

export const communityStats = [
  { label: "在追热点", value: "48", unit: "条", icon: "ri-fire-line" },
  { label: "用户观点", value: "6.8", unit: "万条", icon: "ri-chat-smile-2-line" },
  { label: "社群成员", value: "3.2", unit: "万人", icon: "ri-group-2-line" },
  { label: "今日新增", value: "217", unit: "条", icon: "ri-add-circle-line" },
];

export const aboutValues = [
  {
    id: "v1",
    icon: "ri-eye-line",
    title: "只呈现，不定论",
    desc: "我们整理线索、标注来源和证据完整度，但不会替任何人下结论。真相由时间和事实给出。",
  },
  {
    id: "v2",
    icon: "ri-scales-3-line",
    title: "两派都要说话",
    desc: "每一条瓜下面，支持与质疑的观点都会被保留。我们不追求一边倒的热闹，只想要有内容的争论。",
  },
  {
    id: "v3",
    icon: "ri-user-heart-line",
    title: "不误伤无关的人",
    desc: "代号存在于有意义的地方。没有证据时，我们会尽量把讨论留在事件本身。",
  },
  {
    id: "v4",
    icon: "ri-refresh-line",
    title: "错了就改",
    desc: "内容有误会更新，会标注修改时间。比起永远正确，我们更在意是否诚实。",
  },
];

export const aboutTimeline = [
  { time: "2023 春", text: "从一个几十人的讨论小组开始，大家只做一件事：把散落的信息整理成能看懂的时间线。" },
  { time: "2024 夏", text: "讨论区上线，开始尝试给每条瓜标注来源与证据完整度，而不是只丢一句结论。" },
  { time: "2025 秋", text: "社群入口开放，读者开始自己组织讨论，很多补充材料都来自评论区。" },
  { time: "2026 现在", text: "保持小团队运作，内容仍然以「网友讨论」为底色，不接任何形式的立场投放。" },
];

export const aboutTestimonials = [
  {
    id: "t1",
    user: "追剧二十年",
    avatarBg: "bg-primary-500",
    role: "长期读者 · 影视方向",
    content:
      "最喜欢的是它不给结论。很多地方一上来就告诉你「实锤了」，这里反而会把不确定的地方写清楚，看完了心里有数。",
  },
  {
    id: "t2",
    user: "夜班观察员",
    avatarBg: "bg-secondary-500",
    role: "讨论区常驻",
    content:
      "时间线整理得比我自己做的还细，连设备故障延后多少分钟都标了。对喜欢逐帧比对的人来说真的很友好。",
  },
  {
    id: "t3",
    user: "冷静磕学家",
    avatarBg: "bg-accent-600",
    role: "恋综板块读者",
    content:
      "评论区会有人泼冷水，这点特别难得。看瓜的时候有人提醒你别上头，比一堆人一起加戏有用多了。",
  },
  {
    id: "t4",
    user: "剪过片的人",
    avatarBg: "bg-foreground-700",
    role: "从业者 · 潜水",
    content:
      "作为从业者，能看到有人认真区分「成片证据」和「口头爆料」已经很感动了。希望一直保持这个标准。",
  },
];

export const contentPrinciples = [
  {
    id: "p1",
    icon: "ri-file-search-line",
    title: "先分材料，再谈观点",
    desc: "视频、成片、截图、口头爆料会被分开标注，避免不同强度的材料被放在一起讨论。",
  },
  {
    id: "p2",
    icon: "ri-user-unfollow-line",
    title: "能匿名就不具名",
    desc: "在缺乏确凿材料时使用代号，减少对当事人及无关人员的误伤。",
  },
  {
    id: "p3",
    icon: "ri-time-line",
    title: "时间线优先于结论",
    desc: "我们更愿意多花时间把发生顺序理清楚，而不是抢着给出一个判断。",
  },
  {
    id: "p4",
    icon: "ri-edit-line",
    title: "改稿留痕",
    desc: "内容有更新会标出修改时间与修改原因，方便回头核对的读者。",
  },
  {
    id: "p5",
    icon: "ri-advertisement-line",
    title: "不接立场投放",
    desc: "不接受任何一方以推广、公关或删稿为目的的合作，这是底线。",
  },
  {
    id: "p6",
    icon: "ri-delete-bin-6-line",
    title: "隐私请求优先处理",
    desc: "如涉及非公开个人信息，可来函说明，我们会优先核实并处理。",
  },
];